import { z } from "zod";

/**
 * Subscription form schemas (docs/api-design.md §22, Phase 5 —
 * Subscription, ADR-0009). These only improve client-side UX — the
 * backend (`SubscriptionsService`, `DowngradeService`, ...) always
 * re-validates.
 */

export const createSubscriptionCheckoutSchema = z.object({
  planCode: z.string().trim().min(1).max(64),
  successUrl: z.string().trim().min(1).max(2048),
  cancelUrl: z.string().trim().min(1).max(2048),
});
export type CreateSubscriptionCheckoutInput = z.infer<typeof createSubscriptionCheckoutSchema>;

export const cancelSubscriptionSchema = z.object({
  cancelAtPeriodEnd: z.boolean().optional(),
});
export type CancelSubscriptionInput = z.infer<typeof cancelSubscriptionSchema>;

export const setDowngradeProductSelectionSchema = z.object({
  targetPlanCode: z.string().trim().min(1).max(64).optional(),
  productIdsToKeepActive: z.array(z.string().uuid()).max(1000),
});
export type SetDowngradeProductSelectionInput = z.infer<typeof setDowngradeProductSelectionSchema>;

export const simulateCheckoutPaidSchema = z.object({
  planCode: z.string().trim().min(1).max(64),
});
export type SimulateCheckoutPaidInput = z.infer<typeof simulateCheckoutPaidSchema>;
